/**
 * CurrentCourseHero — the purple "CURRENT COURSE" card.
 *
 * iOS source: HomeScreen.tsx:285-321.
 *   - 120px tall, radius 20, purple gradient #D5CDE6 → #C8BFD9 → #BDB3CF.
 *   - "CURRENT COURSE" overline (white, opacity 0.8) + course title (large
 *     bold white). The parrot-bird illustration sits bottom-right (clipped).
 *
 * The course TITLE is supplied by the courses track's data; this component
 * owns only the visual shell. It is rendered on the Learn page above the
 * course path.
 */
import { FC } from "react";
import { colors } from "@/ui";
import parrot from "../../assets/parrot-bird.png";

export interface CurrentCourseHeroProps {
  courseTitle: string;
  onClick?: () => void;
}

const CurrentCourseHero: FC<CurrentCourseHeroProps> = ({
  courseTitle,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      style={{
        position: "relative",
        width: "100%",
        height: 120,
        borderRadius: 20,
        overflow: "hidden",
        background:
          "linear-gradient(135deg, #D5CDE6 0%, #C8BFD9 55%, #BDB3CF 100%)",
        cursor: onClick ? "pointer" : "default",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        textAlign: "left",
        padding: 20,
        boxSizing: "border-box",
      }}
    >
      <span
        style={{
          fontSize: "var(--base-font-size-xs)",
          fontWeight: 600,
          letterSpacing: 0.5,
          textTransform: "uppercase",
          color: colors.white,
          opacity: 0.8,
          textAlign: "left",
        }}
      >
        Current Course
      </span>
      <span
        style={{
          fontSize: "var(--base-font-size-large)",
          fontWeight: 700,
          color: colors.white,
          marginTop: 4,
          maxWidth: "70%",
          textAlign: "left",
        }}
      >
        {/* iOS prefixes the course title with a 🌱 sprout (HomeScreen course
            card). Guard against double-prefixing if the title already has it. */}
        {courseTitle.trimStart().startsWith("🌱")
          ? courseTitle
          : `🌱 ${courseTitle}`}
      </span>

      {/* Parrot illustration bottom-right, clipped by overflow:hidden. */}
      <img
        src={parrot}
        alt=""
        aria-hidden
        style={{
          position: "absolute",
          right: 8,
          bottom: -6,
          width: 120,
          height: 120,
          objectFit: "contain",
          pointerEvents: "none",
        }}
      />
    </div>
  );
};

export default CurrentCourseHero;
